
import axios from "../utils/axios";
import { PATH_AUTH } from "../routes/paths";
import { decodeJwt } from 'jose';

function jwtDecode(token: string): any {
  return decodeJwt(token);
}

export const isValidToken = (): boolean => {

  const token = sessionStorage.getItem('accessToken');

  if (token == null) return false;

  const decoded = jwtDecode(token);

  const currentTime = Date.now() / 1000;

  if (decoded.exp && decoded.exp > currentTime) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  return decoded.exp && decoded.exp > currentTime;
};

export const getUsername = (): string | null => {

  const token = sessionStorage.getItem('accessToken');

  if (token == null) return null;

  const decoded = jwtDecode(token) as any;

  return decoded.unique_name || null;
};

export const getUserId = (): string | null => {

  const token = sessionStorage.getItem('accessToken');

  if (token == null) return null;

  const decoded = jwtDecode(token) as any;

  return decoded.userId || null;
};

export const getUserSecret = (): string | null => {
  
  const token = sessionStorage.getItem('accessToken');
  if (token == null) return null;
  
  const decoded = jwtDecode(token) as any;
  return decoded.mask || null;
}

export const tokenExpired = (exp: number) => {
  let expiredTimer;

  const currentTime = Date.now();

  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    sessionStorage.removeItem('accessToken');

    window.location.href = PATH_AUTH.login;
  }, timeLeft);
};

export const setSession = (accessToken: string | null) => {
  if (accessToken) {
    sessionStorage.setItem('accessToken', accessToken);


    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    const { exp } = jwtDecode(accessToken);

    if (exp) tokenExpired(exp);
  } else {
    sessionStorage.removeItem('accessToken');

    delete axios.defaults.headers.common.Authorization;
  }
};

export const getSession = (): string | null => {
  const token = sessionStorage.getItem('accessToken');
  return token;
};
